import { SubmitHandler, UseFormReset } from "react-hook-form";

import { ICreateGameData } from "../types/creategame";

import { alertActions } from "../../../features/alert/alertSlice";
import { selectSelectedTeam } from "../../../features/clubhouse/clubhouseSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { createGame } from "../../../lib/api";
import { IGame, ILeague } from "../../../types/api";

const useCreateGameHandlers = (
    reset: UseFormReset<ICreateGameData>,
    leagueId: ILeague["id"],
    setSending: React.Dispatch<React.SetStateAction<boolean>>,
    setSchedule: React.Dispatch<React.SetStateAction<IGame[]>>,
    isOnLeagueManagementPage: boolean,
) => {
    const user = useAppSelector(state => state.auth.user);
    const team = useAppSelector(selectSelectedTeam);
    const dispatch = useAppDispatch();

    const onSubmit: SubmitHandler<ICreateGameData> = async data => {
        setSending(true);
        try {
            const { schedule } = await createGame(
                data,
                leagueId,
                user!.id,
                isOnLeagueManagementPage ? "league" : "team",
                team?.id,
            );

            schedule.games && setSchedule(schedule.games);

            dispatch(
                alertActions.success({
                    title: "Game scheduled successfully",
                    dismissible: true,
                }),
            );
            reset();
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: "The server encountered a problem creating the game.",
                    text: "If the problem continues, please reach out to an admin.",
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };

    return { onSubmit };
};

export default useCreateGameHandlers;
